import { getCSRFToken, setUpdatedCsrfMetaContent } from "../../util";

export async function unfollowCategory(callback, categorySlug) {
  await setUpdatedCsrfMetaContent();

  fetch(`/${I18n.locale}/following_categories`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": getCSRFToken()
    },
    body: JSON.stringify({ category_slugs: [categorySlug] })
  })
    .then(response => response.json())
    .then(data => {
      if (data == null) {
        Toaster.toast("An unknown error occurred", { icon: { classes: "fas fa-times tw-text-danger-500" } });
        throw new Error(`Could not follow category. Error occurred unfollowing on categories index page.`);
      }

      callback();
      _unfollowToast(data.categories[0].name);
    });
}

export async function followCategory(callback, categorySlug, showToast = true) {
  await setUpdatedCsrfMetaContent();

  const categorySlugs = Array.isArray(categorySlug) ? categorySlug : [categorySlug];

  fetch(`/${I18n.locale}/following_categories`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": getCSRFToken()
    },
    body: JSON.stringify({ category_slugs: categorySlugs })
  })
    .then(response => response.json())
    .then(data => {
      if (data == null) {
        Toaster.toast("An unknown error occurred", { icon: { classes: "fas fa-times tw-text-danger-500" } });
        throw new Error(`Could not follow category. Error occurred following on categories index page.`);
      }

      callback(data);
      if (showToast) {
        _followToast(data.categories[0].name);
      }
    })
    .catch(error => {
      Toaster.toast("There was an error while following the category. Please refresh the page and try again", { icon: { classes: "fas fa-times tw-text-danger-500" } });
    });
}

function _followToast(categoryName) {
  Toaster.toast(I18n.t("following_categories.now_following", { category: categoryName }), {
    action: {
      message: I18n.t("following_categories.view_all"),
      options: {
        href: `/${I18n.locale}/categories/following`
      }
    }
  });
}

function _unfollowToast(categoryName) {
  Toaster.toast(I18n.t("following_categories.unfollowed", { category: categoryName }));
}
